'use client'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'

const useQueryParams = () => {
  const searchParams = useSearchParams()
  const pathname = usePathname()
  const router = useRouter()

  const deleteQueryParam = (param: string) => {
    const nextSearchParams = new URLSearchParams(searchParams.toString())
    nextSearchParams.delete(param)
    router.replace(`${pathname}?${nextSearchParams}`)
  }

  const addQueryParam = (name: string, value: string) => {
    const nextSearchParams = new URLSearchParams(searchParams.toString())
    nextSearchParams.append(name, value)
    router.replace(`${pathname}?${nextSearchParams}`)
  }

  const updateQueryParam = (name: string, value: string) => {
    const nextSearchParams = new URLSearchParams(searchParams.toString())
    nextSearchParams.set(name, value) // Use set to update or add the param
    router.replace(`${pathname}?${nextSearchParams}`)
  }

  const getQueryParam = (param: string) => searchParams.get(param)

  return {
    searchParams,
    params: {
      delete: deleteQueryParam,
      get: getQueryParam,
      add: addQueryParam,
      update: updateQueryParam,
    },
  }
}

export default useQueryParams
